module.exports = __webpack_public_path__ + "media/images/new-32-white-a52598b541d7c59f9353c0512347554c.png";